import React from "react";
import { usePagesContext } from "../../contexts";
import { usePageRendering } from "../../hooks";
import { DNDContainer } from "../DNDContainer";
export const ModernContentPane = () => {
    const { mainPages } = usePagesContext();
    const { renderPage } = usePageRendering();
    return (React.createElement("div", { className: "mr-3 mb-3 grow overflow-hidden rounded-lg bg-surface-low" },
        React.createElement(DNDContainer, { style: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                position: "relative",
            } }, mainPages.map(renderPage))));
};
